<template >
    <div class="_content">
        <div class="main-bg">
            <div class="cont-box bgTop">
                <div class="phone row-item bottom-line">
                    <img src="~@/imgs/phone-cc.png" alt="">
                    <div class="phoneInput">
                        <input v-model="phone" type="number" placeholder="请输入手机号" onkeyup="value=value.replace(/[^\d]/g,'')" onblur="value=value.replace(/[^\d]/g,'')" oninput="if(value.length > 11) value = value.slice(0,11)"/>
                        <div v-if="phone.length > 0" class="clear" @click="clear('phone')" ></div>
                    </div>
                </div>

                <div class="yzm row-item">
                    <img src="~@/imgs/locked-cc.png" alt="">
                    <div class="yzmInput">
                        <input v-model="code" type="number" placeholder="请输入验证码" onkeyup="value=value.replace(/[^\d]/g,'')" onblur="value=value.replace(/[^\d]/g,'')" oninput="if(value.length > 6) value = value.slice(0,6)"/>
                        <div v-if="code.length > 0" class="clear" @click="clear('code')" ></div>
                    </div>
                    <span :class="{'activeText':!yzmLock, 'text': yzmLock}" @click="getYzm">{{yzmText}}</span>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="getBtn" @click="clickBtn">
                <tt-button text="立即加盟"></tt-button>
            </div>
            <div class="kefuText">如有疑问请咨询小鲲车服<span v-call>400-176-8848</span></div>
        </div>
    </div>
</template>

<script>
import config from '@/configs/config'
import ttButton from '@/components/ttButton'

export default {
    components: {
        ttButton
    },
    data() {
        return {
            merchantCode:'',
            merchantSignFlag:'',
            signFlag:'',
            source: 1,
            phone: '',
            code: '',
            yzmBtnLock: false, // 按钮
            yzmLock: false, // 倒计时
            joinLock: false, // 加盟
            time: 60,
            shopPhone: '',
            shopNo: ''
        }
    },
    computed: {
        yzmText() {
            if (!this.yzmLock) {
                return '获取验证码'
            } else {
                return `${this.time}秒后重发`
            }
        }
    },
    created() {
        this.init()
    },
    methods: {
        clear(val) {
            this[val] = ''
        },
        async init() {
            this.shopPhone = tuhu.getParam('phone') || ''
            this.shopNo = tuhu.getParam('shopNo') || ''
            this.merchantCode = tuhu.getParam('merchantCode')
            this.merchantSignFlag = tuhu.getParam('merchantSignFlag')
            this.signFlag = tuhu.getParam('signFlag')
            if (this.shopPhone && this.shopNo) this.source = 1
        },
        async getYzm() {
            if (this.phone.length !== 11) return tuhu.toast('请输入正确的手机号')
            if (this.yzmBtnLock) return false
            this.yzmBtnLock = true
            try {
                let res = await tuhu.fetch(`${config.apis.GET_CODE}` + `/${this.phone}/${this.source}`)
                if ((res && res.code === '200') || (res && res.code === 2000)) {
                    this.countDown()
                } else {
                    this.yzmBtnLock = false
                    tuhu.toast(res.message || '网络错误')
                    console.log(`${config.apis.GET_CODE}`, res.message)
                }
            } catch (e) {
                this.yzmBtnLock = false
                console.log(`${config.apis.GET_CODE}`, e)
            }
        },
        countDown() {
            if (this.yzmLock) return
            let timer = setInterval(() => {
                this.yzmLock = true
                this.time--
                if (this.time < 0) {
                    clearInterval(timer)
                    this.time = 10
                    this.yzmLock = false
                    this.yzmBtnLock = false
                }
            }, 1000)
        },
        clickBtn() {
            if (!this.phone || this.phone.length !== 11) return tuhu.toast('请输入正确的手机号')
            if (!this.code) return tuhu.toast('请输入正确的验证码')
            if (this.joinLock) return
            this.joinLock = true
            setTimeout(() => { this.joinLock = false }, 2000)
            if (this.shopPhone && this.shopNo) {
                this.verifyLogin()
            } else {
                this.login()
            }
        },
        async verifyLogin() {
            try {
                const params = {
                    phone: this.phone,
                    desPhone: this.shopPhone,
                    shopId: this.shopNo
                }
                const data = await tuhu.fetch(`${config.apis.SHOP_VERIFY_LOGIN}`, {
                    method: 'post',
                    body: JSON.stringify(params)
                })
                if (data && data.code === '200') {
                    let phone = data.data.desPhone
                    let shopId = data.data.shopId
                    this.login(phone, shopId,this.shopNo)
                } else {
                    tuhu.toast(data.message || '网络异常')
                    console.log(`${config.apis.SHOP_VERIFY_LOGIN}`, data)
                }
            } catch (e) {
                console.log(`${config.apis.SHOP_VERIFY_LOGIN}`, e)
            }
        },
        async login(phone = '', shopId = '', shopNo = '' ) {
            try {
                const params = {
                    phone: this.phone,
                    verificationCode: this.code,
                    source: this.source // 来源
                }
                const data = await tuhu.fetch(`${config.apis.LOGIN}`, {
                    method: 'post',
                    body: JSON.stringify(params)
                })
                if (data && data.code === '200') {
                    tuhu.redirectTo({
                        url: '/pages/cooperationShopInfo/index',
                        query: {
                            phone: phone,
                            shopId: shopId,
                            shopNo:shopNo,
                            merchantCode:this.merchantCode,
                            merchantSignFlag: this.merchantSignFlag,
                            signFlag: this.signFlag
                        }
                    })
                } else {
                    tuhu.toast(data.message || '网络异常')
                    console.log(`${config.apis.LOGIN}`, data)
                }
            } catch (e) {
                console.log(`${config.apis.LOGIN}`, e)
            }
        }
    }
}
</script>

<style lang="less" scoped>
._content {
    background: #F5F5F5;
    display: flex;
    flex-direction: column;
    .main-bg {
        height: 9.5rem;
        padding: 1rem .75rem 0rem .75rem;
        background: url(~@/imgs/bg.png) no-repeat;
        background-size: 100%;
        .cont-box {
            width: 100%;
            display: flex;
            flex-direction: column;
            background: #fff;
            border-radius: .4rem;
            padding: 0 .75rem;
            margin-bottom: .5rem;
            input{
                flex: 1;
                height: 2.8rem;
                margin-left: .75rem;
            }
            .row-item {
                height: 3rem;
                line-height: 3rem;
                position: relative;
                display: flex;
                align-items: center;
                >img{
                    width: .8rem;
                    height: 1rem;
                }
            }
            .phone {
                display: flex;
                .phoneInput {
                    flex: 1;
                    position: relative;
                }
            }
            .yzm {
                display: flex;
                .yzmInput {
                    flex: 1;
                    position: relative;
                }
            }
            .activeText {
                color: rgba(0,110,239,1);
            }
            .text {
                color: #999;
            }
        }
        .bgTop {
            margin-top: 7rem;
        }
    }
    .main {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 0 .75rem;
        .title {
            margin: 2rem 0 .25rem 0;
        }
        .getBtn {
            margin-top: 6rem;
        }
        .kefuText {
            text-align: center;
            margin-bottom: 1rem;
            >span {
                color: rgba(0,110,239,1);
            }
        }
    }
}
.phone .clear {
  background: url(~@/imgs/deleteText.png) no-repeat;
  background-size: contain;
  width: .8rem;
  height: .8rem;
  position: absolute;
  right: 10px;
  top: 1rem;
}
.yzmInput .clear {
  background: url(~@/imgs/deleteText.png) no-repeat;
  background-size: contain;
  width: .8rem;
  height: .8rem;
  position: absolute;
  right: 10px;
  top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/cooperation/index.vue